import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { ViewLeadPopupComponent } from '../view-lead-popup/view-lead-popup.component';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { statuses, oppStatus } from 'src/app/common/events/status.service';
import { NotificationService } from 'src/app/common/events/notificationservice';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-organized-leads',
  templateUrl: './organized-leads.component.html',
  styleUrls: ['./organized-leads.component.css']
})
export class OrganizedLeadsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  filters = {
    type: '',
    search: '',
    staffName: '0',
    status: '0',
    category: '0'
  };
  logsType: string = 'opportunityLogs';
  todayFollowup:number = 0;
  pendingFollowup:number = 0;
  completeFollowup:number = 0;
  expandedRow: number | null = null;
  expandedIndex: number | null = null;
  editIndexRem: number | null = null;
  childData: any;
  followupType: string = 'pending'
  mainModules: any;
  editRowValues: { [rowIndex: number]: { status: string, remarks: string } } = {};
  editIndex: number | null = null;
  saveAttempted = false;
  type: any;
  allStaffRecords: any;
  leadStatusList: any = statuses
  statusList: any = oppStatus
  serviceType: string = '';
  selectedServiceType: string = '';
  statusType: string = 'interested';
  status: number = 5;
  userTypeName: string = '';
  leads: Array<any> = []
  assignedStaff: string = ''
  actualRemarks = [];
  paginatedRecords = [];
  realestateRemarks = [
    "Site Visit done",
    "Negotiation stage",
    "Discussion Stage",
    "Soft Approval Received",
    "Contract & Details sent"
  ]
  fintechRemarks = [
    "Application Filed",
    "Credit Check Completed",
    "Customer Docs Received",
    "Application Filed",
    "Credit Check Completed"
  ]
  propServicesRemarks = [
    "Site Visit Done",
    "Proposal Shared",
    "Negotiation Stage",
    "Catelouge Shared",
    "Models Finalised"
  ]
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;
  constructor(private modalService: NgbModal,
    private rsbService: RsbService,
    public lookupModel: RsbLookupModel,
    private router: Router,
    private toast: ToastrService,
    private notify: NotificationService
  ) { }

  ngOnInit(): void {
    this.serviceType = this.lookupModel.getSelectedServiceType() ? this.lookupModel.getSelectedServiceType() : 'realEstate';
    this.selectedServiceType = this.serviceType
    this.typeServices(9, this.serviceType, this.followupType)
    this.assignedStaff = 'myself'
    this.getStaff()
    this.getOppurtunityCount()
    this.getAllMainModules()
  }

  getOppurtunityCount(): void {
    this.rsbService.getOppurtunityCount({ "status": 9 }, this.filters).subscribe((rsp) => {
      if(rsp.statusCode === 0) {
        this.todayFollowup = rsp.contents.todayFollowups
        this.pendingFollowup = rsp.contents.pendingFollowups
        this.completeFollowup = rsp.contents.completeFollowup
      }
    })
  }

  getAllMainModules(): void {
    this.rsbService.getAllMainModules({}).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.mainModules = rsp.contents
      }
    })
  }



  clearSearch() {
    this.filters.search = '';
    this.applyFilters()
  }

  applyFilters(): void {
    this.typeServices(9, this.serviceType, this.followupType)
  }

  resetFilters() {
    this.filters = {
      type: '',
      search: '',
      staffName: '',
      status: '0',
      category: '0'
    };
    this.applyFilters()
  }

  saveRemark(lead: any, index: number) {
    const rowValues = this.editRowValues[index];
    const remarks = rowValues.remarks.trim();
    const status = Number(rowValues.status);
    if (status === 0 || remarks.length < 5) {
      this.saveAttempted = true;
      this.toast.warning('Select a status and enter at least 5 characters for remarks.');
      return;
    }

    this.saveAttempted = false;
    if (status === 5) {
      this.view(lead, status, remarks)
    } else {
      this.viewStatus(lead, status, remarks)
      // this.rsbService.addOppFranchiseLogs({ opportunityStatus: Number(this.editRowValues[index].status), status: lead.status, leadId: lead.leadId, franchiseId: lead.franchiseId, remarks: this.editRowValues[index].remarks, description: this.editRowValues[index].remarks }).subscribe((rsp) => {
      //   if (rsp.statusCode === 0) {
      //     if (Number(this.editRowValues[index].status) === 5) {
      //       this.view(lead, Number(this.editRowValues[index].status), this.editRowValues[index].remarks)
      //     } else {
      //       this.typeServices(9, this.serviceType, this.followupType)
      //     }

      //   }

      // })
    }
    this.editIndex = null; // Exit edit mode
  }

  closeEdit(index: number) {
    this.editIndex = null
    this.saveAttempted = false;
    delete this.editRowValues[index];
  }

  startEditingRow(index: number) {
    this.editIndex = index;
    this.saveAttempted = false;
    this.editRowValues[index] = { status: '0', remarks: '' }; // default status = "0"
  }



  generateTitle(leadRec) {
    switch (leadRec.product) {
      case 'Villa':
      case 'Apartment':
      case 'Independent House':
      case 'Flat': {
        const att = this.checkAttributes(leadRec.attributes || []); // assuming this is a method that processes Attr
        if (att) {
          return `${att} ${leadRec.product}`;
        } else {
          return leadRec.product
        }
      }
      case 'Plot':
      case 'Land': {
        const size = leadRec.measurementName ? `${leadRec.measurementName} ` : '';
        return `${leadRec.propertySize} ${size} ${leadRec.product}`;
      }
      default:
        return leadRec.product || 'Unknown Property';
    }
  }

  checkAttributes(attributes: []): string {
    let attributesRes: any = {}
    if (attributes.length) {
      attributesRes = attributes.find((obj: any) => {
        return obj.attributeName.toUpperCase() === "BHK"
      })
    }
    let res = ''
    if (Object.values(attributesRes).length > 0) {
      res = attributesRes?.attributePropertyName + ' ' + 'BHK';
    }
    return res;
  }
  getStaff(): void {
    this.rsbService.getStaffDataWithoutPagination().subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.allStaffRecords = rsp.contents
      }
    })
  }
  getLeads(type: string): void {
    this.statusType = type;
    if (type === 'interested') {
      this.status = 5;
      this.typeServices(this.status, this.serviceType, this.followupType);
    } else if (type === 'dead') {
      this.status = 4;
      this.typeServices(this.status, this.serviceType, this.followupType)
    } else if (type === 'notInterested') {
      this.status = 3;
      this.typeServices(this.status, this.serviceType, this.followupType)
    } else {
      alert('Something went wrong');
    }
  }
  typeServices(status: number, serType: string, followupType?: string, ui?: boolean): void {
    if (ui) {
      this.filters = {
        type: '',
        search: '',
        staffName: '0',
        status: '0',
        category: '0'
      };
    }
    this.followupType = followupType;
    this.serviceType = serType;
    if (serType === 'realEstate') {
      this.actualRemarks = this.realestateRemarks
      if (this.followupType === 'pending') {
        this.rsbService.getOppurtunityPendingFollowup({ "status": 9 }, this.filters, this.pageSize, this.pageIndex).subscribe((rsp) => {
          if (rsp?.statusCode === 0 && rsp.contents.items?.length) {
            this.leads = rsp.contents.items;
            this.totalRecords = rsp.contents.total;
            this.updatePaginatedRecords()
          } else {
            this.leads = []
            this.updatePaginatedRecords()
          }
          this.getOppurtunityCount()
        });
      } else if (this.followupType === 'today') {
        this.rsbService.getOpportunityTodayFollowup({ "status": 9 }, this.filters, this.pageSize, this.pageIndex).subscribe((rsp) => {
          if (rsp?.statusCode === 0 && rsp.contents.items?.length) {
            this.leads = rsp.contents.items;
            this.totalRecords = rsp.contents.total;
            this.updatePaginatedRecords()
          } else {
            this.leads = []
            this.updatePaginatedRecords()
          }
          this.getOppurtunityCount()
        });
      } else {
        this.rsbService.getOpportunityCompleteFollowup({ "status": 9 }, this.filters, this.pageSize, this.pageIndex).subscribe((rsp) => {
          if (rsp?.statusCode === 0 && rsp.contents.items?.length) {
            this.leads = rsp.contents.items;
            this.totalRecords = rsp.contents.total;
            this.updatePaginatedRecords()
          } else {
            this.leads = []
            this.updatePaginatedRecords()
          }
          this.getOppurtunityCount()
        });
      }
    } else if (serType === 'finTech') {
      this.actualRemarks = this.fintechRemarks
      this.rsbService.getAssignedFintechLeadsForFranchise({ "status": status }).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else if (serType === 'propService') {
      this.actualRemarks = this.propServicesRemarks
      this.rsbService.getAssignedPropServiceLeadsForFranchise({ "status": status }).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else {
      alert('Something went wrong');
    }
  }

  updatePaginatedRecords() {
    this.notify.getCalendarData();
    this.paginatedRecords = this.leads;
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Verified Lead':
        return 'status-verified';
      case 'Qualified Lead':
        return 'status-qualified';
      default:
        return 'status-default';
    }
  }

  getLeadTypeClass(type: string): string {
    switch (type) {
      case 'Online':
      case 'online':
        return 'lead-online';
      case 'Walkin':
        return 'lead-walkin';
      case 'Referral':
        return 'lead-referral';
      default:
        return 'lead-default';
    }
  }

  getCategoryClass(category: string): string {
    switch (category) {
      case 'Sale':
        return 'category-sale';
      case 'Rent':
        return 'category-rent';
      case 'Loans':
      case 'loans':
        return 'cat-loan';
      case 'Housing':
        return 'category-housing';
      case 'creditCard':
        return 'cat-credit-card'
      default:
        return 'category-default';
    }
  }

  getProductClass(product: string): string {
    switch (product) {
      case 'Villa':
        return 'product-villa';
      case 'Apartment':
        return 'product-apartment';
      case 'Land':
        return 'product-land';
      case 'Flat':
        return 'product-flat';
      case 'Plot':
        return 'product-plot';
      case 'Housing':
        return 'product-housing'; // Add this line
      case 'eduloan':
      case 'Edu Loan':
        return 'product-edu-loan'; // Add this line
      case 'Home Loan':
        return 'home-loan';
      case 'LAP':
        return 'laploan'; // Add this line
      case 'Personal/Self':
        return 'personalloan'; // Add this line
      case 'CCTV':
        return 'cctv'; // Add this line
      case 'Interior':
        return 'interior'; // Add this line
      case 'Furniture':
        return 'furniture'; // Add this line
      case 'Packers And Movers':
        return 'packers'; // Add this line

      default:
        return 'product-default';
    }
  }
  redirectUrl(data: any): void {
    let url = '';
    switch (data.moduleName.toUpperCase()) {
      case 'RENT':
      case 'BUY':
        url =
          'https://pillarblocks.com/property-details/' +
          encodeURIComponent(data.propertyTitle.replaceAll(' ', '-')) +
          '?listingId=' + data.propertyId +
          '&cat=' + data.categoryId +
          '&subcat=' + data.subCategoryId +
          '&module=' + data.moduleId +
          '&country=hCDjcS' +
          '&city=' + encodeURIComponent(data.city) +
          '&area=' + encodeURIComponent(data.area) +
          '&pincode=' + data.pincode;
        break;

      case 'PROJECTS':
        url =
          'https://pillarblocks.com/project-description/' +
          encodeURIComponent(data.projectName) +
          '?projectId=' + data.projectId +
          '&cat=' + data.categoryId +
          '&subcat=' + data.subCategoryId +
          '&country=hCDjcS' +
          '&city=' + encodeURIComponent(data.city) +
          '&area=' + encodeURIComponent(data.area) +
          '&pincode=' + data.pincode;
        break;
      case 'Plot & Land':
        url = 'https://pillarblocks.com/'
      case 'PG / HOSTELS':
      // url = 'https://pillarblocks.com/'
      case 'COMMERCIAL':
        // TODO: Build URLs for these modules if needed
        break;
    }
    if (url) {
      window.open(url, '_blank'); // open in new tab
    }
  }
  selectService(service: string) {
    this.selectedServiceType = service;
    this.serviceType = service;
    this.lookupModel.setSelectedServiceType(this.serviceType);
    //this.typeServices(this.lookupModel.getLoggedUser().type, service);
    this.typeServices(this.status, service, this.followupType);
  }

  selectStaff(event) {
    if (event.target.value! == '0') {
      this.filters.type = this.lookupModel.getLoggedUser().type === 'franchise' ? 'staff' : 'substaff'
    } else {
      this.filters.type = ''
    }
  }

  assignedFunctionStaff(service: string) {
    this.assignedStaff = service
  }

  viewStatus(leads: any, status, remarks): void {
    const modalRef = this.modalService.open(ViewLeadPopupComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.leadStatus = leads.status
    modalRef.componentInstance.statusSelected = leads.status
    modalRef.componentInstance.oppStatus = status
    modalRef.componentInstance.remarks = remarks
    modalRef.result.then((result) => {
      let payload = {}
      result.status = Number(result.status);
      payload = {
        id: this.lookupModel.getLoggedUser().franchiseId,
        status: result.status,
        leadId: leads.leadId,
        propertyId: leads.propertyId,
        description: result.remarks,
        remarks: result.remarks,
        date: result.date,
        propType: this.serviceType,
        opportunityStatus: status,
        productValue: leads.productValue,
        actualCost: result.actualProductCost
      }
      this.rsbService.addOppFranchiseLogs(payload).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.typeServices(9, this.serviceType, this.followupType)
          this.notify.getCalendarData()
          //this.router.navigate(['sales'])
          //this.followupRedirectedMethod(result)
        }
      })


    })
  }

  view(leads: any, status, remarks): void {
    const modalRef = this.modalService.open(ViewLeadPopupComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.leadStatus = 12
    modalRef.componentInstance.statusSelected = 12
    modalRef.componentInstance.oppStatus = status
    modalRef.componentInstance.remarks = remarks
    modalRef.result.then((result) => {
      let payload = {}
      result.status = Number(result.status);
      payload = {
        id: this.lookupModel.getLoggedUser().franchiseId,
        status: result.status,
        leadId: leads.leadId,
        propertyId: leads.propertyId,
        description: result.remarks,
        remarks: result.remarks,
        propType: this.serviceType,
        opportunityStatus: status,
        productValue: leads.productValue,
        actualCost: result.actualProductCost
      }
      this.rsbService.convertToSales(payload).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.toast.success('Lead Successfully converted to Sales');
          this.router.navigate(['sales'])
          //this.followupRedirectedMethod(result)
        }
      })


    })
  }

  redirectMethod(result: any): void {
    if (result.status == "4") {
      this.toast.success('Lead Successfully updated to Dead Lead');
      this.router.navigate(['Leads']);
    } else if (result.status == "5") {
      this.toast.success('Lead Successfully updated to Interested Lead');
      this.router.navigate(['Leads']);
    } else if (result.status == "3") {
      this.toast.success('Lead Successfully updated to Not Interested Lead');
      this.router.navigate(['Leads']);
    } else {
      this.toast.success('Lead Successfully updated to Organized Lead');
      this.router.navigate(['organizedLeads']);
    }
  }

  toggleRowForChange(index: number) {
    if (this.logsType === 'leadLogs') {
      this.rsbService.getFranchiseLogs({ franchiseId: this.lookupModel.getLoggedUser().franchiseId, leadId: this.leads[index].leadId }).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.childData = rsp.contents
        }
      })
    } else if (this.logsType === 'followupLogs') {
      this.rsbService.getFollowupDetailsOfLead(this.leads[index].leadId).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.childData = rsp.contents
        }
      })
    } else {
      this.rsbService.getOppFranchiseLogs({ franchiseId: this.lookupModel.getLoggedUser().franchiseId, leadId: this.leads[index].leadId }).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.childData = rsp.contents
        }
      })
    }
  }

  getStatusName(value: number): string {
    const status = this.statusList.find(s => s.value === value);
    return status ? status.name : '';
  }

  getOppStatusName(value: number): string {
    const status = this.leadStatusList.find(s => s.value === value);
    return status ? status.name : '';
  }


  changeLogsType(type: string, index: number): void {
    this.logsType = type
    this.toggleRowForChange(index)
  }

  followupRedirectedMethod(result: any): void {
    const inputDate = new Date(result.date);
    const today = new Date();

    // Normalize both dates to remove time components for accurate comparison
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (inputDate > today) {
      this.router.navigate(['FollowUp']); // Date is in the future
    } else if (inputDate < today) {
      this.router.navigate(['FollowUp']); // Date is in the past
    } else {
      this.router.navigate(['FollowUp']); // Date is today
    }
  }

  toggleRow(index: number) {
    this.rsbService.getOppFranchiseLogs({ franchiseId: this.lookupModel.getLoggedUser().franchiseId, leadId: this.leads[index].leadId }).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.childData = rsp.contents
        this.expandedIndex = this.expandedIndex === index ? null : index;
      }
    })

  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.typeServices(9, this.serviceType, this.followupType)
  }

}


